module.exports = {
  head: {
    title: 'Privacy Statement and Cookies Policy | Recipe Boxes | Gousto',
    meta: [
      {
        name: 'description',
        content: 'Learn how Gousto manages your data and cookies with our Privacy Statement and Cookies Policy. Read the full policy documents today.',
      },
      {
        name: 'keywords',
        content: 'Gousto, recipe delivery, ingredients, fresh, healthy food, cooking',
      },
    ],
  },
}
